import { Colors, Styles } from "../preset.constants";

export const breadcrumbPreset = {
    gap: Styles.Gap,
    root: {
        background: Colors.PrimaryBackground
    },
    item: {
        color: Colors.SecondaryTextColor,
        hover: {
            color: Colors.SecondaryTextColor,
        }
    },

}